export default async function (context) {
  // If the user is not authenticated
  if (context.$cookie.get('token')) {
    let currentPageRoute = 'dashboard'
    const menubarTab = context.store.state.settings.menubarTab
    const userPermissions = context.store.state.settings.userPermissions
    const route = context.route.path.replace(/\/$/, '') || '/'
    const isCurrentRoute = to => {
      if (!to) return false
      const menuRoute = to.replace(/\/$/, '') || '/'
      return route === menuRoute || (menuRoute !== '/' && route.startsWith(`${menuRoute}/`))
    }

    for (const menu of menubarTab) {
      const matchingChild = menu.children?.find(child => isCurrentRoute(child.to))
      if (matchingChild) {
        currentPageRoute = matchingChild.code || menu.code
        break
      }
      if (isCurrentRoute(menu.to)) {
        currentPageRoute = menu.code
        break
      }
    }

    const userData = context.$cookie.get('user')

    if (userData && userData.user_type !== 1) {
      await context.store.dispatch('settings/permissionCode', currentPageRoute) // The save the current route permission code into cookies
      if (userPermissions.length === 0) {
        await context.store.dispatch('settings/userPermissions') // To fetch the user permissions data
      }
    }
  }
}
